import { useNavigate } from 'react-router-dom'
import { ShieldAlert, RefreshCw } from 'lucide-react'
import { authApi } from '@/lib/api/auth'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { useState } from 'react'

export default function DevicePendingPage() {
  const navigate = useNavigate()
  const [isRetrying, setIsRetrying] = useState(false)

  const handleTryAgain = async () => {
    setIsRetrying(true)
    try {
      const res = await authApi.getMicrosoftUrl()
      if (!res.success || !res.data) {
        setIsRetrying(false)
        return
      }
      sessionStorage.setItem('ms_oauth_state', res.data.state)
      window.location.href = res.data.url
    } catch {
      setIsRetrying(false)
    }
  }

  const handleUseDifferentDevice = () => {
    localStorage.removeItem('portal_device_id')
    navigate('/login', { replace: true })
  }

  return (
    <div className="min-h-screen bg-[#0B2545] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8 gap-3">
          <img src="/logo.png" alt="Monarch Innovation" className="h-12 w-auto" />
          <p className="text-slate-400 text-sm">Corporate Payment Portal</p>
        </div>

        <Card className="shadow-2xl border-white/10 bg-white">
          <CardHeader className="pb-4 text-center">
            <div className="flex justify-center mb-3">
              <ShieldAlert className="h-12 w-12 text-amber-500" />
            </div>
            <CardTitle className="text-xl">Device Awaiting Approval</CardTitle>
            <CardDescription>
              Your device has been registered but requires administrator approval before you can
              access the portal.
            </CardDescription>
          </CardHeader>

          <CardContent className="space-y-4">
            <p className="text-sm text-muted-foreground text-center">
              Please contact your administrator and ask them to approve your device from the Users
              page. Once approved, click "Try Again" below.
            </p>

            <Button
              type="button"
              className="w-full"
              onClick={handleTryAgain}
              disabled={isRetrying}
            >
              {isRetrying ? (
                <RefreshCw className="mr-2 h-4 w-4 animate-spin" />
              ) : (
                <RefreshCw className="mr-2 h-4 w-4" />
              )}
              Try Again
            </Button>

            <div className="text-center">
              <button
                type="button"
                onClick={handleUseDifferentDevice}
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Use a different device
              </button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
